import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap"; // Import Button

import { Label } from "reactstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { array, date } from "yup";

// ... (other imports)

const SearchByStatus = (props) => {
  const [year, setYear] = useState([]); 
  const [year1, setYear1] = useState([]); 
  // First set
  const [startMonth1, setStartMonth1] = useState("");
  const [endMonth1, setEndMonth1] = useState("");
  const [salary1, setSalary1] = useState("");

  // Second set
  const [startMonth2, setStartMonth2] = useState("");
  const [endMonth2, setEndMonth2] = useState("");
  const [salary2, setSalary2] = useState("");

  // Third set
  const [startMonth3, setStartMonth3] = useState("");
  const [endMonth3, setEndMonth3] = useState("");
  const [salary3, setSalary3] = useState("");

  const monthRangeError = "Please select a valid month range.";
  const salaryError = "Please provide a valid salary .";
  useEffect(() => {
    
    // Set the year dropdown to the default year from props
     const selectedYearObject =props.yearOptions?.find(item => item.value === props.defaultYear);
    setYear(
      {value: selectedYearObject?.value, label: selectedYearObject?.label}
   );
   setYear1(
    {value: selectedYearObject?.value, label: selectedYearObject?.label}
 );
  }, [props.yearOptions]
  
  );
  const validateMonthRange = (startMonth, endMonth, setNumber, prevEndMonth) => {
    if (startMonth !== "" && endMonth !== "") {
      const startMonthNum = parseInt(startMonth);
      const endMonthNum = parseInt(endMonth);

      if (startMonthNum > endMonthNum || startMonthNum <= prevEndMonth) {
        return false;
      }
    }
    return true;
  };
	const validateSalary = (salary) => {
    return salary !== "" && !isNaN(parseFloat(salary)) && isFinite(salary);
  };
  
  const validateSelection = () => {
    const isSet1Valid = validateMonthRange(startMonth1.value, endMonth1.value, 1, 0);
  
    if (startMonth2 === "" && startMonth3 === "") {
      // No data selection in 2nd and 3rd fieldsets
      if (isSet1Valid && endMonth1.value === "12") {
        if (!validateSalary(salary1)) {
          return salaryError;
        } else {
          return "";
        }
      } else {
        return monthRangeError;
      }
    } else if (startMonth3 === "") {
      // No data selection in 3rd fieldset
      if (
        isSet1Valid &&
        validateMonthRange(startMonth2.value, endMonth2.value, 2, endMonth1.value) &&
        endMonth2.value === "12"
      ) {
        if (!validateSalary(salary1) || !validateSalary(salary2)) {
          return salaryError;
        } else {
          return "";
        }
      } else {
        return monthRangeError;
      }
    } else {
      // Selection in all fieldsets
      if (
        isSet1Valid &&
        validateMonthRange(startMonth2.value, endMonth2.value, 2, endMonth1.value) &&
        validateMonthRange(startMonth3.value, endMonth3.value, 3, endMonth2.value) &&
        endMonth3.value === "12"
      ) {
        if (!validateSalary(salary1) || !validateSalary(salary2) || !validateSalary(salary3)) {
          return salaryError;
        } else {
          return "";
        }
      } else {
        return monthRangeError;
      }
    }
  };
  

  const handleCalculate = () => {
    props.setErrorMessage(""); 
    const validateMessage=validateSelection();
    if (validateMessage=="") {
      props.getByYear(year.value,startMonth1.value,endMonth1.value,salary1,startMonth2.value,endMonth2.value,salary2,startMonth3.value,endMonth3.value,salary3/* other parameters */);
      // Your calculation logic here
      props.setErrorMessage(""); 
    }else{
      props.setErrorMessage(validateMessage);
    } 
  };
  const handleReset = () => {
    // Reset all fields
  
    setYear("");
    setStartMonth1("");
    setEndMonth1("");
    setSalary1("");
    setStartMonth2("");
    setEndMonth2("");
    setSalary2("");
    setStartMonth3("");
    setEndMonth3("");
    setSalary3("");
  };

  return (
    <Form className="salary-status-row">
      <Row className="row">
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0" style={{ marginRight: "60px" }}>
              Year
            </Label>
            {props.medicalCalculations && (
        <> 
        <CustomReactSelect
           className="input"
           value={year}
           onChange={(obj) => setYear(obj)} // Use setYear instead of setYear(obj)
           options={props.yearOptions}
          
         />
            </>
      )}
            {!props.medicalCalculations && (
        <> 
        <CustomReactSelect
           className="input"
           value={year1}
           onChange={(obj) => {
            setYear1(obj) // Use setYear instead of setYear(obj)
            if (!props.medicalCalculations) {
              
              props.getByYear(obj.value, "", "", "", "", "", "", "", "");
            }
          }}
           options={props.yearOptions}
          
         />
            </>
      )}
           
          </Form.Group>
        </Col>
        <Col></Col>
        <Col></Col>
        <Col></Col>
        <Col>
        {props.medicalCalculations && (
        <>  <Button style={{ float: "right" }} onClick={handleCalculate}>
            Calculate
          </Button>
          {year || startMonth1 || endMonth1 || salary1 ||
                startMonth2 || endMonth2 || salary2 ||
                startMonth3 || endMonth3 || salary3 ? (
                <Button variant="danger" style={{ float: "right", marginRight: "10px" }} onClick={handleReset}>
                  Reset
                </Button>
              ) : null}
            </>
      )}
        </Col>
      </Row>
      {props.medicalCalculations && (
        <>
      <Row className="row">
        {/* First set */}
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0" style={{ marginRight: "15px" }}>
              Start Month
            </Label>
            <CustomReactSelect
              className="input"
              value={
                startMonth1
              }
              onChange={(obj) => setStartMonth1(obj)}
              options={props.monthOptions}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0" style={{ marginRight: "15px" }}>
              End Month
            </Label>
            <CustomReactSelect
              className="input"
               value={
               endMonth1
              }
              onChange={(obj) => setEndMonth1(obj)}
              options={props.monthOptions}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0">Salary</Label>
            <Form.Control
              type="number"
              onChange={(e) => setSalary1(e.target.value)}
              className="input"
              value={
                salary1
               }
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value))
                  .toString()
                  .slice(0, 7);
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="row">
        
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0" style={{ marginRight: "15px" }}>
              Start Month
            </Label>
            <CustomReactSelect
              className="input"
              value={
                startMonth2
              }
              onChange={(obj) => setStartMonth2(obj)}
              options={props.monthOptions}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0" style={{ marginRight: "15px" }}>
              End Month
            </Label>
            <CustomReactSelect
              className="input"
              value={
                endMonth2
              }
              onChange={(obj) => setEndMonth2(obj)}
              options={props.monthOptions}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0">Salary</Label>
            <Form.Control
              type="number"
              onChange={(e) => setSalary2(e.target.value)}
              className="input"
              value={
                salary2
              }
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value))
                  .toString()
                  .slice(0, 7);
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="row">
        {/* Third set */}
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0" style={{ marginRight: "15px" }}>
              Start Month
            </Label>
            <CustomReactSelect
              className="input"
              value={
                startMonth3
              }
              onChange={(obj) => setStartMonth3(obj)}
              options={props.monthOptions}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0" style={{ marginRight: "15px" }}>
              End Month
            </Label>
            <CustomReactSelect
              className="input"
              value={
                endMonth3
              }
              onChange={(obj) => setEndMonth3(obj)}
              options={props.monthOptions}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="d-flex align-items-center ml-4">
            <Label className="mb-0">Salary</Label>
            <Form.Control
              type="number"
              onChange={(e) => setSalary3(e.target.value)}
              className="input"
              value={
                salary3
              }
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value))
                  .toString()
                  .slice(0, 7);
              }}
            />
          </Form.Group>
        </Col>
      </Row>  </>
      )}
    </Form>
  );
};

export default SearchByStatus;
